import React, { useContext, useRef } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Typography from "@mui/material/Typography";
import { InputTextarea } from "primereact/inputtextarea";
import { isMobile } from "react-device-detect";
import { ServiciosContext } from "../../context/ServiciosContext";
import PAI from "./PAI";

export default function VGI() {
  const isPortrait = window.matchMedia("(orientation: portrait)").matches;
  const acMedica = useRef();
  const acSocial = useRef();
  const acPsicologica = useRef();
  const acNutricional = useRef();
  const {
    barthel,
    fragilidad,
    lawtonBrody,
    goldberg,
    tinetti,
    norton,
    examenIII,
    valoracionSocial,
    evaluacionNutricional,
    escalaValoracionMental,
    frases,
    reloj,
    guardarExamenIII,
  } = useContext(ServiciosContext);

  const sumarPreguntasGoldberg = (inicio) =>
    Array.from({ length: 9 }, (_, index) =>
      Number(goldberg?.[`pregunta${inicio + index * 2}`] || 0)
    ).reduce((total, valor) => total + valor, 0);

  const detallesDiagnosticoNutricional = {
    A: "A - Bien nutrido",
    B: "B - Sospecha de malnutrición o malnutrición moderada",
    C: "C - Malnutrición severa",
  };
  const resultadoGoldberg =
    goldberg && !Array.isArray(goldberg)
      ? `${sumarPreguntasGoldberg(1)} / ${sumarPreguntasGoldberg(2)}`
      : "";
  return (
    <Grid container spacing={3} style={{ padding: "1rem" }}>            <Grid item xs={12} md={12}>
              <Typography variant="h6" style={{ textDecoration: "underline" }}>
                VALORACION GERIATRICA INTEGRAL: Conclusión
              </Typography>
            </Grid>

            <Grid item xs={12} md={12}>
              <Typography variant="h6" style={{ textDecoration: "underline" }}>
                Funcional
              </Typography>
            </Grid>

            <Grid item xs={12} md={4} style={{ marginTop: "-1vw" }}>
              <TextField
                value={
                  barthel
                    ? Number(barthel.comer ? barthel.comer : 0) +
                      Number(barthel.lavarse ? barthel.lavarse : 0) +
                      Number(barthel.vestirse ? barthel.vestirse : 0) +
                      Number(barthel.arreglarse ? barthel.arreglarse : 0) +
                      Number(barthel.deposiciones ? barthel.deposiciones : 0) +
                      Number(barthel.miccion ? barthel.miccion : 0) +
                      Number(barthel.retrete ? barthel.retrete : 0) +
                      Number(barthel.trasladarse ? barthel.trasladarse : 0) +
                      Number(barthel.deambular ? barthel.deambular : 0) +
                      Number(barthel.escalones ? barthel.escalones : 0)
                    : null
                }
                id="barthel"
                label="ABVD BARTHEL"
                fullWidth
                variant="standard"
              />
            </Grid>

            <Grid item xs={12} md={4} style={{ marginTop: "-1vw" }}>
              <TextField
                value={
                  lawtonBrody
                    ? Number(
                        lawtonBrody.telefonoResultado
                          ? lawtonBrody.telefonoResultado
                          : 0
                      ) +
                      Number(
                        lawtonBrody.comprasResultado
                          ? lawtonBrody.comprasResultado
                          : 0
                      ) +
                      Number(
                        lawtonBrody.comidaResultado
                          ? lawtonBrody.comidaResultado
                          : 0
                      ) +
                      Number(
                        lawtonBrody.casaResultado
                          ? lawtonBrody.casaResultado
                          : 0
                      ) +
                      Number(
                        lawtonBrody.ropaResultado
                          ? lawtonBrody.ropaResultado
                          : 0
                      ) +
                      Number(
                        lawtonBrody.transporteResultado
                          ? lawtonBrody.transporteResultado
                          : 0
                      ) +
                      Number(
                        lawtonBrody.medicacionResultado
                          ? lawtonBrody.medicacionResultado
                          : 0
                      ) +
                      Number(
                        lawtonBrody.economicoResultado
                          ? lawtonBrody.economicoResultado
                          : 0
                      )
                    : null
                }
                id="lawton"
                label="AIVB LAWTON"
                fullWidth
                variant="standard"
              />
            </Grid>

            <Grid item xs={12} md={4} style={{ marginTop: "-1vw" }}>
              <TextField
                value={
                  tinetti
                    ? (Number(
                        tinetti.equilibrioSentado
                          ? tinetti.equilibrioSentado
                          : 0
                      ) +
                      Number(tinetti.levantarse ? tinetti.levantarse : 0) +
                      Number(
                        tinetti.intentoLevantarse
                          ? tinetti.intentoLevantarse
                          : 0
                      ) +
                      Number(
                        tinetti.equilibrioSegundos
                          ? tinetti.equilibrioSegundos
                          : 0
                      ) +
                      Number(
                        tinetti.equilibrioProlongado
                          ? tinetti.equilibrioProlongado
                          : 0
                      ) +
                      Number(
                        tinetti.rombergSensibilizado
                          ? tinetti.rombergSensibilizado
                          : 0
                      ) +
                      Number(tinetti.romberg ? tinetti.romberg : 0) +
                      Number(tinetti.girar ? tinetti.girar : 0) +
                      Number(tinetti.girar2 ? tinetti.girar2 : 0) +
                      Number(tinetti.sentarse ? tinetti.sentarse : 0)) +
                      " / 16"
                    : null
                }
                id="tinetti"
                label="TINETTI"
                fullWidth
                variant="standard"
              />
            </Grid>

            <Grid item xs={12} md={4} style={{ marginTop: "-1vw" }}>
              <TextField
                value={
                  escalaValoracionMental
                    ? Number(
                        escalaValoracionMental.pregunta1
                          ? escalaValoracionMental.pregunta1Value
                          : 0
                      ) +
                      Number(
                        escalaValoracionMental.pregunta2
                          ? escalaValoracionMental.pregunta2Value
                          : 0
                      ) +
                      Number(
                        escalaValoracionMental.pregunta3
                          ? escalaValoracionMental.pregunta3Value
                          : 0
                      ) +
                      Number(
                        escalaValoracionMental.pregunta4
                          ? escalaValoracionMental.pregunta4Value
                          : 0
                      ) +
                      Number(
                        escalaValoracionMental.pregunta5
                          ? escalaValoracionMental.pregunta5
                          : 0
                      ) +
                      Number(
                        escalaValoracionMental.pregunta6
                          ? escalaValoracionMental.pregunta6Value
                          : 0
                      ) +
                      Number(
                        escalaValoracionMental.pregunta7
                          ? escalaValoracionMental.pregunta7Value
                          : 0
                      ) +
                      Number(
                        escalaValoracionMental.pregunta8
                          ? escalaValoracionMental.pregunta8Value
                          : 0
                      ) +
                      Number(
                        escalaValoracionMental.pregunta9
                          ? escalaValoracionMental.pregunta9Value
                          : 0
                      ) +
                      Number(
                        escalaValoracionMental.pregunta10
                          ? escalaValoracionMental.pregunta10Value
                          : 0
                      ) +
                      Number(
                        escalaValoracionMental.pregunta11
                          ? escalaValoracionMental.pregunta11Value
                          : 0
                      ) +
                      Number(
                        escalaValoracionMental.pregunta12
                          ? escalaValoracionMental.pregunta12Value
                          : 0
                      ) +
                      Number(
                        escalaValoracionMental.pregunta13
                          ? escalaValoracionMental.pregunta13Value
                          : 0
                      ) +
                      Number(
                        escalaValoracionMental.pregunta14
                          ? escalaValoracionMental.pregunta14Value
                          : 0
                      ) +
                      Number(
                        escalaValoracionMental.pregunta15
                          ? escalaValoracionMental.pregunta15Value
                          : 0
                      )
                    : null
                }
                id="lobo"
                label="MINIMENTAL"
                fullWidth
                variant="standard"
              />
            </Grid>

            <Grid item xs={12} md={4} style={{ marginTop: "-1vw" }}>
              <TextField
                value={resultadoGoldberg}
                id="depresion"
                label="DEPRESION"
                fullWidth
                variant="standard"
              />
            </Grid>

            <Grid item xs={12} md={4} style={{ marginTop: "-1vw" }}>
              <TextField
                value={
                  norton
                    ? Number(norton.estadoFisico ? norton.estadoFisico : 0) +
                      Number(norton.estadoMental ? norton.estadoMental : 0) +
                      Number(norton.actividad ? norton.actividad : 0) +
                      Number(norton.movilidad ? norton.movilidad : 0) +
                      Number(norton.incontinencia ? norton.incontinencia : 0)
                    : null
                }
                id="norton"
                label="NORTON"
                fullWidth
                variant="standard"
              />
            </Grid>

            <Grid item xs={12} md={4} style={{ marginTop: "-1vw" }}>
              <TextField
                value={
                  fragilidad
                    ? Number(
                        fragilidad.pregunta1 ? fragilidad.pregunta1Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta2 ? fragilidad.pregunta2Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta3 ? fragilidad.pregunta3Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta4 ? fragilidad.pregunta4Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta5 ? fragilidad.pregunta5Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta6 ? fragilidad.pregunta6Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta7 ? fragilidad.pregunta7Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta8 ? fragilidad.pregunta8Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta9 ? fragilidad.pregunta9Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta10 ? fragilidad.pregunta10Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta11 ? fragilidad.pregunta11Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta12 ? fragilidad.pregunta12Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta13 ? fragilidad.pregunta13Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta14 ? fragilidad.pregunta14Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta15 ? fragilidad.pregunta15Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta16 ? fragilidad.pregunta16Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta17 ? fragilidad.pregunta17Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta18 ? fragilidad.pregunta18Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta19 ? fragilidad.pregunta19Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta20 ? fragilidad.pregunta20Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta21 ? fragilidad.pregunta21Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta22 ? fragilidad.pregunta22Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta23 ? fragilidad.pregunta23Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta24 ? fragilidad.pregunta24Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta25 ? fragilidad.pregunta25Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta26 ? fragilidad.pregunta26Value : 0
                      ) +
                      Number(
                        fragilidad.pregunta27 ? fragilidad.pregunta27Value : 0
                      )
                    : null
                }
                id="fragilidad"
                label="FRAGILIDAD"
                fullWidth
                variant="standard"
              />
            </Grid>

            <Grid item xs={12} md={4} style={{ marginTop: "-1vw" }}>
              <TextField
                value={
                  reloj
                    ? Number(reloj.esfera ? reloj.esfera : 0) +
                      Number(
                        reloj.numero && reloj.numero / 10 === 3.5
                          ? reloj.numero / 10
                          : reloj.numero && reloj.numero / 10 !== 3.5
                          ? Math.trunc(reloj.numero / 10)
                          : 0
                      ) +
                      Number(
                        reloj.aguja && reloj.aguja / 10 === 3.5
                          ? reloj.aguja / 10
                          : reloj.aguja && reloj.aguja / 10 !== 3.5
                          ? Math.trunc(reloj.aguja / 10)
                          : 0
                      )
                    : null
                }
                id="reloj"
                label="TEST DEL RELOJ"
                fullWidth
                variant="standard"
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <Typography variant="h6" style={{ textDecoration: "underline" }}>
                Médica
              </Typography>
            </Grid>

            <Grid item xs={12} md={12}>
              <Autocomplete
                id="frases"
                ref={acMedica}
                fullWidth
                options={
                  frases
                    ? frases.filter(
                        (element) =>
                          element.habilitado && element.tipo === "medica"
                      )
                    : null
                }
                disablePortal
                getOptionLabel={(option) => option.frase}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="Frases Médicas"
                    size="small"
                  />
                )}
                onChange={(event, value) => {
                  if (value && value.frase && value.frase !== null) {
                    if (examenIII.vgimedica && examenIII.vgimedica.length > 0) {
                      guardarExamenIII({
                        ...examenIII,
                        vgimedica: examenIII.vgimedica + value.frase + "\n",
                      });
                    } else {
                      guardarExamenIII({
                        ...examenIII,
                        vgimedica: value.frase + "\n",
                      });
                    }
                    setTimeout(() => {
                      const ele = acMedica.current.getElementsByClassName(
                        "MuiAutocomplete-clearIndicator"
                      )[0];
                      if (ele) ele.click();
                    }, 1000);
                  }
                }}

                //onKeyDown={handleEnter}
              />
            </Grid>
            <Grid item xs={12} md={12} style={{ margin: "1vw", width: "auto" }}>
              <Grid item xs={12} md={12}>
                <InputTextarea
                  value={
                    examenIII && examenIII.vgimedica
                      ? examenIII.vgimedica
                      : null
                  }
                  onChange={(e) =>
                    guardarExamenIII({
                      ...examenIII,
                      vgimedica: e.target.value,
                    })
                  }
                  rows={5}
                  cols={
                    isMobile && !isPortrait
                      ? 90
                      : isMobile && isPortrait
                      ? 30
                      : 120
                  }
                />
              </Grid>
            </Grid>

            <Grid item xs={12} md={12}>
              <Typography variant="h6" style={{ textDecoration: "underline" }}>
                Social
              </Typography>
            </Grid>            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                multiline
                minRows={3}
                label="Diagnóstico Social"
                value={valoracionSocial?.diagnostico || ""}
                variant="standard"
                InputProps={{ readOnly: true }}
              />
            </Grid>


            <Grid item xs={12} md={12}>
              <Autocomplete
                id="frases"
                ref={acSocial}
                fullWidth
                options={
                  frases
                    ? frases.filter(
                        (element) =>
                          element.habilitado && element.tipo === "social"
                      )
                    : null
                }
                disablePortal
                getOptionLabel={(option) => option.frase}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="Frases Sociales"
                    size="small"
                  />
                )}
                onChange={(event, value) => {
                  if (value && value.frase && value.frase !== null) {
                    if (examenIII.vgisocial && examenIII.vgisocial.length > 0) {
                      guardarExamenIII({
                        ...examenIII,
                        vgisocial: examenIII.vgisocial + value.frase + "\n",
                      });
                    } else {
                      guardarExamenIII({
                        ...examenIII,
                        vgisocial: value.frase + "\n",
                      });
                    }
                    setTimeout(() => {
                      const ele = acSocial.current.getElementsByClassName(
                        "MuiAutocomplete-clearIndicator"
                      )[0];
                      if (ele) ele.click();
                    }, 1000);
                  }
                }}

                //onKeyDown={handleEnter}
              />
            </Grid>
            <Grid item xs={12} md={12} style={{ margin: "1vw", width: "auto" }}>
              <Grid item xs={12} md={12}>
                <InputTextarea
                  value={
                    examenIII && examenIII.vgisocial
                      ? examenIII.vgisocial
                      : null
                  }
                  onChange={(e) =>
                    guardarExamenIII({
                      ...examenIII,
                      vgisocial: e.target.value,
                    })
                  }
                  rows={5}
                  cols={
                    isMobile && !isPortrait
                      ? 90
                      : isMobile && isPortrait
                      ? 30
                      : 120
                  }
                />
              </Grid>
            </Grid>

            <Grid item xs={12} md={12}>
              <Typography variant="h6" style={{ textDecoration: "underline" }}>
                Psicológica
              </Typography>
            </Grid>

            <Grid item xs={12} md={12}>
              <Autocomplete
                id="frases"
                ref={acPsicologica}
                fullWidth
                options={
                  frases
                    ? frases.filter(
                        (element) =>
                          element.habilitado && element.tipo === "psicologica"
                      )
                    : null
                }
                disablePortal
                getOptionLabel={(option) => option.frase}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="Frases Psicológicas"
                    size="small"
                  />
                )}
                onChange={(event, value) => {
                  if (value && value.frase && value.frase !== null) {
                    if (
                      examenIII.vgipsicologica &&
                      examenIII.vgipsicologica.length > 0
                    ) {
                      guardarExamenIII({
                        ...examenIII,
                        vgipsicologica:
                          examenIII.vgipsicologica + value.frase + "\n",
                      });
                    } else {
                      guardarExamenIII({
                        ...examenIII,
                        vgipsicologica: value.frase + "\n",
                      });
                    }
                    setTimeout(() => {
                      const ele = acPsicologica.current.getElementsByClassName(
                        "MuiAutocomplete-clearIndicator"
                      )[0];
                      if (ele) ele.click();
                    }, 1000);
                  }
                }}

                //onKeyDown={handleEnter}
              />
            </Grid>
            <Grid item xs={12} md={12} style={{ margin: "1vw", width: "auto" }}>
              <Grid item xs={12} md={12}>
                <InputTextarea
                  value={
                    examenIII && examenIII.vgipsicologica
                      ? examenIII.vgipsicologica
                      : null
                  }
                  onChange={(e) =>
                    guardarExamenIII({
                      ...examenIII,
                      vgipsicologica: e.target.value,
                    })
                  }
                  rows={5}
                  cols={
                    isMobile && !isPortrait
                      ? 90
                      : isMobile && isPortrait
                      ? 30
                      : 120
                  }
                />
              </Grid>
            </Grid>

            <Grid item xs={12} md={12}>
              <Typography variant="h6" style={{ textDecoration: "underline" }}>
                Nutricional
              </Typography>
            </Grid>            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                label="Diagnóstico Nutricional"
                value={
                  detallesDiagnosticoNutricional[
                    evaluacionNutricional?.diagnosticoNutricional
                  ] || ""
                }
                variant="standard"
                InputProps={{ readOnly: true }}
              />
            </Grid>


            <Grid item xs={12} md={12}>
              <Autocomplete
                id="frases"
                ref={acNutricional}
                fullWidth
                options={
                  frases
                    ? frases.filter(
                        (element) =>
                          element.habilitado && element.tipo === "nutricional"
                      )
                    : null
                }
                disablePortal
                getOptionLabel={(option) => option.frase}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="Frases Nutricionales"
                    size="small"
                  />
                )}
                onChange={(event, value) => {
                  if (value && value.frase && value.frase !== null) {
                    if (
                      examenIII.vginutricional &&
                      examenIII.vginutricional.length > 0
                    ) {
                      guardarExamenIII({
                        ...examenIII,
                        vginutricional:
                          examenIII.vginutricional + value.frase + "\n",
                      });
                    } else {
                      guardarExamenIII({
                        ...examenIII,
                        vginutricional: value.frase + "\n",
                      });
                    }
                    setTimeout(() => {
                      const ele = acNutricional.current.getElementsByClassName(
                        "MuiAutocomplete-clearIndicator"
                      )[0];
                      if (ele) ele.click();
                    }, 1000);
                  }
                }}

                //onKeyDown={handleEnter}
              />
            </Grid>
            <Grid item xs={12} md={12} style={{ margin: "1vw", width: "auto" }}>
              <Grid item xs={12} md={12}>
                <InputTextarea
                  value={
                    examenIII && examenIII.vginutricional
                      ? examenIII.vginutricional
                      : null
                  }
                  onChange={(e) =>
                    guardarExamenIII({
                      ...examenIII,
                      vginutricional: e.target.value,
                    })
                  }
                  rows={5}
                  cols={
                    isMobile && !isPortrait
                      ? 90
                      : isMobile && isPortrait
                      ? 30
                      : 120
                  }
                />
              </Grid>
            </Grid>

            <Grid item xs={12} md={12}>
              <Typography variant="h6" style={{ textDecoration: "underline" }}>
                Visual
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} style={{ margin: "1vw", width: "auto" }}>
              <Grid item xs={12} md={12}>
                <InputTextarea
                  value={
                    examenIII && examenIII.conclusionVisual
                      ? examenIII.conclusionVisual
                      : null
                  }
                  onChange={(e) =>
                    guardarExamenIII({
                      ...examenIII,
                      conclusionVisual: e.target.value,
                    })
                  }
                  rows={5}
                  cols={
                    isMobile && !isPortrait
                      ? 90
                      : isMobile && isPortrait
                      ? 30
                      : 120
                  }
                />
              </Grid>
            </Grid>

            <Grid item xs={12} md={12}>
              <Typography variant="h6" style={{ textDecoration: "underline" }}>
                Auditiva
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} style={{ margin: "1vw", width: "auto" }}>
              <Grid item xs={12} md={12}>
                <InputTextarea
                  value={
                    examenIII && examenIII.conclusionAuditiva
                      ? examenIII.conclusionAuditiva
                      : null
                  }
                  onChange={(e) =>
                    guardarExamenIII({
                      ...examenIII,
                      conclusionAuditiva: e.target.value,
                    })
                  }
                  rows={5}
                  cols={
                    isMobile && !isPortrait
                      ? 90
                      : isMobile && isPortrait
                      ? 30
                      : 120
                  }
                />
              </Grid>
            </Grid>

      <Grid item xs={12}>
        <PAI />
      </Grid>

    </Grid>
  );
}